module.exports = __webpack_public_path__ + "static/media/contact-bg.98adb1bc.png";